import { PermissionDenied } from '@components/PermissionDenied';
import { useAuth } from '@contexts/AuthContext';
import { Loader, Log } from '@swyft/core';
import React, { FC } from 'react';
import { Route, RouteProps } from 'react-router';

export interface PrivateRouteProps extends RouteProps {
  permission: string;
}

export const PrivateRoute: FC<PrivateRouteProps> = ({ component, permission, ...rest }) => {
  var { hasPermission, isAuthenticated, isLoading, signInRedirect } = useAuth();

  React.useEffect(() => {
    if (isAuthenticated || isLoading) {
      return;
    }

    Log.info('PrivateRoute : SignInSilentError => Redirect');
    signInRedirect();
  }, [isAuthenticated, isLoading, signInRedirect]);

  if (isLoading) {
    Log.debug('PrivateRoute', 'No auth state / loading:', isLoading);
    return <Loader />;
  }

  if (!hasPermission(permission)) {
    Log.info('PrivateRoute:PermissionDenied');
    return <PermissionDenied />;
  }

  return <Route component={component} {...rest} />;
};
